/* eslint-disable @typescript-eslint/naming-convention */

import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';

// IconButtonのスタイル
export const StyledIconButton = styled(IconButton)({
	'&:hover': {
		backgroundColor: '#00000000',
	},
	'&:active': {
		backgroundColor: '#00000000',
	},
	'&:focus': {
		backgroundColor: '#00000000',
	},
});
